<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="formulaire">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-6 col-xs-12">
                <form [formGroup]="registerform">
                    <div class="cust_input_box">
                        <input type="text" name='nom' formControlName="prenom" placeholder="Prénom">
                        <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                    <img src="assets/images/nom.svg" alt="">
                    <span  class="text-red-plus">*</span>
                        </span>
                    </div>
                    <div class="cust_input_box">
                        <input type="text" name='nom' formControlName="nom" placeholder="Nom">
                        <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                    <img src="assets/images/nom.svg" alt="">
                    <span  class="text-red-plus">*</span>
                        </span>
                    </div>
                    <div class="cust_input_box">
                        <input type="text" name='email' formControlName="email" placeholder="Email">
                        <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                    <img src="assets/images/icon-email.svg" alt="">
                    <span  class="text-red-plus">*</span>
                        </span>
                    </div>
                    <div class="cust_input_box">
                        <!-- (hasError)="hasError($event,'numeroTelephone','assure')" -->
                        <input type="text" formControlName="telephone" numberOnly class="input-tel" name='telephone' placeholder="Téléphone" ng2TelInput [ng2TelInputOptions]="{initialCountry: 'sn'}" clearInput (focus)="isFocus=true" (blur)="isFocus=false" (ng2TelOutput)="getNumber($event,'telephone','registerform')"
                            (intlTelInputObject)="telInputObject($event)" (countryChange)="onCountryChange($event)" />
                    </div>

                </form>
                <div class="text-danger text-center mt-1" *ngIf="userInconnu!=''"> {{userInconnu}}
                </div>
                <div class="custom_connexion">
                    <button type="button" class="btn btn-primary" (click)="inscription()">
                        S'inscrire
                        <i class="fal fa-spinner fa-pulse" *ngIf="loaderVisible"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <!-- <p>Vous avez déjà un compte?</p> -->
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Close click')">Fermer</button>
</div>